export const ENDPOINTS = {
  AUTHORIZE: '/oauth2/authorize',
  TOKEN: '/oauth2/token',
  LOGOUT: '/oauth2/logout',
  END_SESSION: '/oauth2/end-session',
} as const;
